export default __webpack_public_path__ + "static/media/redCard.9a9e0ae5.png";